module.exports = __webpack_public_path__ + "static/second_source-27ce9e8ea4728124ce70501d32746346.png";